import { all, fork } from "redux-saga/effects"

//public
import AccountSaga from "./auth/register/saga"
import AuthSaga from "./auth/login/saga"
import ForgetSaga from "./auth/forgetpwd/saga"
import ProfileSaga from "./auth/profile/saga"
import LayoutSaga from "./layout/saga"
import dashboardSaga from "./dashboard/saga"
import rolesSaga from "./roles/saga"
import usersSaga from "./user/saga"
import carParkSaga from "./carpark/saga"
import seasonPassSaga from "./season-pass/saga"
import guestSaga from "./guest/saga"
import auditSaga from "./audit/saga"
import billSaga from "./bill/saga"
import settingsSaga from "./settings/saga"
import carparTicketSaga from "./tickets/saga"
import adminSaga from "./admin/saga"
import specialDatesSaga from "./specialdates/saga"
import blacklistsSaga from "./blacklists/saga"

export default function* rootSaga() {
  yield all([
    //public
    fork(AccountSaga),
    fork(AuthSaga),
    fork(ForgetSaga),
    fork(ProfileSaga),
    fork(LayoutSaga),
    fork(rolesSaga),
    fork(usersSaga),
    fork(dashboardSaga),
    fork(carParkSaga),
    fork(seasonPassSaga),
    fork(guestSaga),
    fork(auditSaga),
    fork(billSaga),
    settingsSaga(),
    fork(carparTicketSaga),
    fork(adminSaga),
    fork(specialDatesSaga),
    fork(blacklistsSaga),
  ])
}
